// extracted by mini-css-extract-plugin
module.exports = {"h1":"Headings_h1__1js1k","h2":"Headings_h2__1dgPE","h5":"Headings_h5__26j5g"};